import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=0c2b2f7a&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c2b2f7a')) {
      api.createRecord('0c2b2f7a', component.options)
    } else {
      api.reload('0c2b2f7a', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=0c2b2f7a&", function () {
      api.rerender('0c2b2f7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ZEvfgtQtQ2nZ/JS/comp/ErrorMessage.vue"
export default component.exports